import React from "react";
import { BsPersonWorkspace } from "react-icons/bs";

const WorkspaceButton = ({ showWorkspace, setShowWorkspace, label = "Workspace" }) => {
  const handleClick = () => {
    setShowWorkspace(!showWorkspace);
  };

  return (
    <button
      className="btn d-flex align-items-center ui-wp rotated-btn" style={{ backgroundColor: '#a3cefa' }}
      onClick={handleClick}
    >
      <BsPersonWorkspace size={20} className="me-1" />
      {label}
    </button>
  );
};

export default WorkspaceButton;
